import {CommonDropdown} from "root/ReactHookForm/ui/CommonDropdown";

import SpinnerDiv from "ui/ReactSpinnerDiv";
import useListboxFetch from "root/ReactHookForm/ui/useListboxFetch";

const DropdownSIMSSchool = ({onChange}) =>
{
    const fields = { url: '/simsload/schools', keyFieldName: 'school_id', labelFieldName: 'school_name', additionalFields: ['enc_school_id'] }

    const [ isLoading, items ] = useListboxFetch( fields ) ;

    return (
        <div>
            {isLoading === false && <CommonDropdown items={items} onChange={onChange}/>}
            {isLoading === true && <SpinnerDiv/>}
        </div>
    )
}

export default DropdownSIMSSchool;